export enum NetworkEnum {
  Ethereum = 1,
  Base = 2,
  Arbitrum = 3,
  BNBChain = 4,
  Solana = 5
}

export const NetworkLabel: Record<NetworkEnum, string> = {
  [NetworkEnum.Ethereum]: 'Ethereum',
  [NetworkEnum.Base]: 'Base',
  [NetworkEnum.Arbitrum]: 'Arbitrum',
  [NetworkEnum.BNBChain]: 'BNB Chain',
  [NetworkEnum.Solana]: 'Solana',
};
